import mixpanel from "mixpanel-browser";
import React, { useEffect, useState } from "react";
import { IoArrowBackSharp, IoFlagSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/MadeWithQubio.png";
import Loader from "../../component/loader";
import { useGetPageQuery } from "../../redux/slices/pageSlice";
import { useCreateReportMutation } from "../../redux/slices/reportSlice";
import Reported from "./Reported";
import "./report.css";
import { useAppContext } from './../../util'

// ReportPage component
const ReportPage = () => {
  const { userId, pageId } = useAppContext()
  const [pageUrl, setPageUrl] = useState("");
  const [deviceHeight, setDeviceHeigth] = useState("");
  const { color } = useSelector((state) => state.color);

  const { data } = useGetPageQuery(`/api/v1/page/web/${userId}/${pageId}`, {
    skip: userId ? false : true,
  });

  const [createPage, { isLoading, isError, error, isSuccess }] =
    useCreateReportMutation();
  useEffect(() => {
    setPageUrl(data?.pageUrl);
  }, [data]);

  useEffect(() => {
    setDeviceHeigth(window.innerHeight);
    document.body.style.background = color;
  }, []);

  const handleReport = async (e) => {
    e.preventDefault();
    const formData = {
      pageUrl,
    };
    const response = await createPage(formData);
    mixpanel.track(
      "Report Page", 
      {
        distinct_id: userId,
        stack_id: pageId,
      }
    )
  };
  return (
    <div
      id="reportmain"
      style={{
        padding: "1rem",
        backgroundColor: "#1F2937",
        margin: "0px auto",
        height: `calc(${deviceHeight}px)`,
      }}
    >
      <div
        className="report-container"
        style={{
          position: "relative",
        }}
      >
        <>
          <Link to={`/?userId=${userId}&pageId=${pageId}`}>
            <IoArrowBackSharp className="back-icon" />
          </Link>
          {isLoading ? (
            <div className="reportBox">
              <Loader width={"40px"} />
            </div>
          ) : isSuccess ? (
            <Reported />
          ) : (
            <div className="reportBox">
              <span className="report-title">
                <IoFlagSharp />
              </span>
              <span className="report-subtitle">Report this content</span>
              <span className="report-description">
                Our team will remove this content if it breaches our policies
              </span>
              <span className="report-button" onClick={handleReport}>
                Report it
              </span>
            </div>
          )}
        </>
        <footer className="bottom-container">
          <img src={Logo} alt="" className="bottom-text" />

          <div
            style={{
              width: "85%",
              margin: "10px auto",
              borderRadius: "16px",
              background: "white",
            }}
          >
            <a
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                listStyle: "none",
                textDecoration: "none",
                padding: "15px",
              }}
              href={"https://qubio.me"}
              target="_blank" rel="noreferrer"
            >
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: 500,
                  lineHeight: "24px",
                  color: "#1F2937",
                }}
              >
                {"Learn more"}
              </p>
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
};

// export component ReportPage
export default ReportPage;
